import { LinearGradient } from 'expo-linear-gradient'
import { Box, Button, Text, IBoxProps, IButtonProps, ITextProps } from 'native-base'
import { StyleSheet } from 'react-native'

import { radii, space } from '~constants/theme'

type PropsType = {
  buttonLabel: string
  buttonProps: IButtonProps
  children?: JSX.Element | JSX.Element[] | null
  componentProps?: IBoxProps
  textProps?: ITextProps
  withShadow?: boolean
}

export const BottomComponentWithButton = ({
  buttonLabel = 'buttonLabel',
  buttonProps = {},
  children = null,
  componentProps = {},
  textProps = {},
  withShadow = true,
}: PropsType) => {
  return (
    <Box zIndex={10}>
      {withShadow ? (
        <LinearGradient
          colors={['transparent', 'rgba(0,0,0,0.9)']}
          style={styles.linearGradient}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 0.8 }}
        />
      ) : null}
      <Box w="full" bg="white" mt="auto" pt="4" roundedTop="xl" {...componentProps}>
        {children}
        <Button bg="actionBlue" mb="4" mx="4" {...buttonProps}>
          <Text color="white" bold {...textProps}>
            {buttonLabel}
          </Text>
        </Button>
      </Box>
    </Box>
  )
}

const styles = StyleSheet.create({
  linearGradient: {
    ...StyleSheet.absoluteFillObject,
    borderRadius: radii.xl,
    top: -space[3],
    zIndex: -10,
  },
})
